import React from 'react';
import { Modal } from 'antd';
import { Feedback } from '@components';
import styles from './index.module.scss';

interface RateModalProps {
  visible: boolean;
  onCancel: () => void;
}

const RateModal: React.FC<RateModalProps> = ({ visible, onCancel }) => {
  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      centered
      className={styles.rateModal}
      title="Rate This Story">
      <div className={styles.modalContent}>
        <Feedback />
      </div>
    </Modal>
  );
};

export default RateModal;
